<template>
  <div class="flex flex-col lg:w-auto">
    <div class="flex text-nowrap bg-[url('/img/enervon_c/label.svg')] bg-no-repeat w-max bg-[100%] h-[60px] px-[20px] justify-items-center items-center" v-bind:class="{'lg:self-end': props.rtl}">
      <span class="font-extrabold text-white" v-bind:class="{ 'text-md': props.title.length > 20, 'text-xl': props.title.length <= 20}">{{props.title}}</span>
    </div>
    <p class="text-white font-semibold ml-[8px] ld:ml-[0px]" v-html="props.text"></p>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
    title: String,
    text: String,
    rtl: Boolean,
});
</script>